import { EventNames } from '../../../types/misc.types'
import { goBack, trackEvent } from '../../../utils/appBridge'
import { CloseButton } from './CloseButton'
import { getTopPadding } from '../../../utils/sessionStorage'

export const TopBar = ({ ScreenName, screenType }: { ScreenName: string; screenType?: string }) => {
  const handleClose = () => {
    const payload: { eventId: string; ScreenName: string; screenType?: string } = { eventId: 'close', ScreenName }
    if (screenType) payload.screenType = screenType
    trackEvent({ eventName: EventNames.ButtonTap, payload })
    goBack()
  }
  return (
    <div style={{ paddingTop: `calc(${getTopPadding()}px + 8px)` }} className='w-full px-6 pb-6'>
      <div className='ml-auto w-max'>
        <CloseButton onClose={handleClose} />
      </div>
    </div>
  )
}
